<template>
  <div class="storeView_w" v-if="shopInfo">
    <div class="head_w d_flex align_item_c justify_content_sb fz14">
      <div class="d_flex align_item_c">
        <span class="store_icon" />
        <span :title="shopInfo.name" class="store_name text_ellipsis c_4D4D4D">{{ shopInfo.name }}</span>
      </div>
    </div>

    <div class="main_w fz12">
      <div class="desc_item">
        <span class="label ">联  系  人：</span>
        <span class="value">{{ shopInfo.contact }}</span>
      </div>
      <div class="desc_item">
        <span class="label ">联系电话：</span>
        <span class="value">{{ shopInfo.hotline }}</span>
      </div>
      <div class="desc_item">
        <span class="label ">联系地址：</span>
        <span class="value">{{ shopInfo.address }}</span>
      </div>
    </div>

    <div class="bottom_w x_y_center">
      <div class="go_btn  text_center cursor_pointer c_fff" @click="goStoreClick">进入店铺</div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  props: {
    itemDetail: {
      type: Object,
      default: () => null
    }
  },


  computed:{
    shopInfo(){
      return this.itemDetail.shopInfo
    }
  },

  created() {
    console.log('500000')
  },
  methods: {
    goStoreClick() {
      let token = Cookies.get('token')
      window.open( token ? `${this.shopInfo.domain}/?token=${token}`:this.shopInfo.domain , '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.storeView_w{
  width: 240px;

  border: 1px solid #E6E6E6;
  margin-left: 10px;
}
.store_icon{
  display: inline-block;
  width: 24px;
  height: 24px;
  background: #B5A088;
  border-radius: 50%;
  margin-right: 10px;
}
.store_name{
  width: 160px;
}
.head_w{
    height: 63px;
    line-height: 63px;
    padding: 0 10px 0 20px;
  }
  .go_btn{
    width: 198px;
    height: 34px;
    line-height: 34px;
    background-color: #3D9DD6;
    margin: 29px 0;
  }
  .main_w{
    height: 196px;
    padding: 0 20px;
    border-top: 1px solid #E6E6E6;

    border-bottom: 1px solid #E6E6E6;

    .desc_item{
      margin: 18px 0;
    }
    .label{
      color: #808080;
    }
    .value{
      color: #4d4d4d;
    }
  }
  .bottom_w{

  }
</style>
